const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 17 75 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-587.6-532.4h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-575.6-537.8-581-532.4-587.6-532.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-587.6-303.7h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-575.6-309.1-581-303.7-587.6-303.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-587.6-75.1h-133.9c-6.6,0-12-5.4-12-12V-221c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-575.6-80.5-581-75.1-587.6-75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-587.6,153.6h-133.9c-6.6,0-12-5.4-12-12V7.7c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-575.6,148.2-581,153.6-587.6,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-587.6,382.2h-133.9c-6.6,0-12-5.4-12-12V236.3c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-575.6,376.8-581,382.2-587.6,382.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-587.6,610.8h-133.9c-6.6,0-12-5.4-12-12V465c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-575.6,605.4-581,610.8-587.6,610.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-587.6,839.5h-133.9c-6.6,0-12-5.4-12-12V693.6c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-575.6,834.1-581,839.5-587.6,839.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-587.6,1068.1h-133.9c-6.6,0-12-5.4-12-12V922.2c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-575.6,1062.7-581,1068.1-587.6,1068.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M55.7,127.5H27.4c-0.6,0-1-0.4-1-1v-100c0-0.6,0.4-1,1-1h28.2c0.6,0,1,0.4,1,1v100C56.7,127.1,56.2,127.5,55.7,127.5z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45.3,
    y1: 38.7,
    x2: 56.7,
    y2: 38.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 49.1,
    y1: 46.3,
    x2: 56.7,
    y2: 46.3
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45.3,
    y1: 53.9,
    x2: 56.7,
    y2: 53.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 49.1,
    y1: 61.4,
    x2: 56.7,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45.3,
    y1: 69,
    x2: 56.7,
    y2: 69
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 49.1,
    y1: 76.5,
    x2: 56.7,
    y2: 76.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45.3,
    y1: 84.1,
    x2: 56.7,
    y2: 84.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 49.1,
    y1: 91.6,
    x2: 56.7,
    y2: 91.6
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45.3,
    y1: 99.2,
    x2: 56.7,
    y2: 99.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 49.1,
    y1: 106.8,
    x2: 56.7,
    y2: 106.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45.3,
    y1: 114.3,
    x2: 56.7,
    y2: 114.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/Ruler.8fde302af4ab956bd03c9bed5e85c9a0.svg";
export { ForwardRef as ReactComponent };